import React, { useEffect, useState } from "react";
import * as ReactDOMClient from 'react-dom/client';
import Spinner from "../Common/Spinner";
import ProfileActivities from "./Components/ProfileActivities";
import ProfileInfo from "./Components/ProfileInfo";
import ProfileMissions from "./Components/ProfileMissions";
import { ProfileService } from "@/common/api/Services/Profile";
const Profile = () => {
    // @ts-ignore
    const userId = window?.userId ?? 0;
    const [profileInfo, setProfileInfo] = useState();
    const [pageStatus, setPageStatus] = useState("loading");
    const getProfileInfo = async () => {
        try {
            const res = await ProfileService.getProfileInfo(userId);
            setProfileInfo(res);
            setPageStatus("success");
        }
        catch {
            setPageStatus("error");
        }
    };
    useEffect(() => {
        getProfileInfo();
    }, []);
    if (pageStatus === "loading") {
        return React.createElement(Spinner, null);
    }
    if (pageStatus === "error") {
        return (React.createElement("div", { className: "text-center" },
            React.createElement("h2", null, "an error occurred"),
            React.createElement("p", { className: "secondary-color mt-2" }, "Please try refreshing the page")));
    }
    if (!profileInfo) {
        return React.createElement(React.Fragment, null);
    }
    return (React.createElement("div", null,
        React.createElement(ProfileInfo, { user: profileInfo }),
        React.createElement(ProfileMissions, { userId: userId, userName: profileInfo.firstName + " " + profileInfo.lastName }),
        React.createElement(ProfileActivities, { userId: userId, userName: profileInfo.firstName })));
};
const rctProfile = document.getElementById("rct-profile");
if (rctProfile !== null) {
    ReactDOMClient.createRoot(rctProfile).render(React.createElement(Profile, null));
}
